import { useMemo } from "preact/hooks";
import { useLocation } from "react-router-dom";

export default function useIsGlobalSearch() {
  const { pathname } = useLocation();

  return useMemo(() => {
    const segments = pathname.split("/");

    return segments[segments.indexOf("dashboard") + 1] === "search";
  }, [pathname]);
}
